import React, { useState, useEffect } from 'react';
import { evenementService } from '../../api';
import './EvenementInscription.css';

const EvenementInscription = ({ evenementId }) => {
  const [state, setState] = useState({
    loading: false,
    error: null,
    isInscrit: false,
    notes: ''
  });

  useEffect(() => {
    const checkInscription = async () => {
      try {
        const res = await evenementService.checkInscription(evenementId);
        setState(prev => ({ ...prev, isInscrit: res.data.is_inscrit }));
      } catch (error) {
        setState(prev => ({ ...prev, error: error.message }));
      }
    };
    checkInscription();
  }, [evenementId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setState(prev => ({ ...prev, loading: true, error: null }));
    
    try {
      if (state.isInscrit) {
        await evenementService.desinscrire(evenementId);
      } else {
        await evenementService.inscrire(evenementId, state.notes);
      }
      setState(prev => ({
        ...prev,
        isInscrit: !prev.isInscrit,
        loading: false
      }));
    } catch (error) {
      setState(prev => ({
        ...prev,
        error: error.response?.data?.message || 'Erreur',
        loading: false
      }));
    }
  };

  return (
    <div className="inscription-container">
      {state.error && <div className="error">{state.error}</div>}
      
      <form onSubmit={handleSubmit}>
        {!state.isInscrit && (
          <textarea
            value={state.notes}
            onChange={(e) => setState(prev => ({ ...prev, notes: e.target.value }))}
            placeholder="Notes (optionnel)"
          />
        )}
        
        <button type="submit" disabled={state.loading}>
          {state.loading ? 'Chargement...' 
           : state.isInscrit ? 'Se désinscrire' : "S'inscrire"}
        </button>
      </form>
    </div>
  );
};

export default EvenementInscription;